function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0A0D0D",
  d: "M7.92058628,19.8789042 L14.1010334,13.6914189 C14.6319121,13.1570383 14.2557343,12.2500161 13.5033786,12.2500161 L9.85417542,12.2500161 L9.85417542,5.21878286 C9.85417542,4.75121271 9.47799758,4.37503487 9.01042743,4.37503487 L5.63543548,4.37503487 C5.16786534,4.37503487 4.79168749,4.75121271 4.79168749,5.21878286 L4.79168749,12.2500161 L1.14598619,12.2500161 C0.393664836,12.2500161 0.0174869913,13.1605745 0.548331368,13.6914189 L6.72527663,19.8789042 C7.05575833,20.2093858 7.59010459,20.2093858 7.92058628,19.8789042 Z",
  transform: "matrix(1 0 0 -1 0 20.502)"
});

var SvgArrowUp = function SvgArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-up.1b705727.svg";
export { ForwardRef as ReactComponent };